import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "organic", "recyclable", "wast", "total", "months", "period", "measure", "dashboardData" ]

  connect() {
    var cleave = new Cleave(".input-vat-number", {
      delimiters: [".", ".", "/", "-"],
      blocks: [2, 3, 3, 4, 2],
    })
  }
}